const tabs = {
    normal: {
        cursor: ({ isActive, isDisabled }) => {
            if (isActive || isDisabled) {
                return 'not-allowed';
            }
            return 'pointer';
        },
        textColor: ({ isActive, isDisabled, isError }) => {
            if (isError) {
                return 'RED_700';
            }
            if (isActive && !isDisabled) {
                return 'INK_800';
            }
            if (!isActive && isDisabled) {
                return 'INK_400';
            }
            return 'INK_600';
        },
        textShadow: ({ isActive }) => {
            if (isActive) {
                return '0 0 0.0625rem';
            }
            return '0 0 0';
        },
        borderColor: ({ isActive, isError }) => {
            if (isActive && isError) {
                return 'RED_700';
            }
            if (isActive && !isError) {
                return 'INK_800';
            }
            return 'transparent';
        },
    },
    hover: {
        textColor: ({ isActive, isDisabled, isError }) => {
            if (isError) {
                return 'RED_700';
            }
            if (isActive && !isDisabled) {
                return 'INK_800';
            }
            if (!isActive && isDisabled) {
                return 'INK_400';
            }
            return 'PRIMARY_600';
        },
        borderColor: ({ isActive, isDisabled, isError }) => {
            if (isActive && !isDisabled && !isError) {
                return 'INK_800';
            }
            if (!isActive && isDisabled && !isError) {
                return 'transparent';
            }
            if (!isActive && !isDisabled && isError) {
                return 'RED_300';
            }
            if (isActive && !isDisabled && isError) {
                return 'RED_700';
            }
            return 'PRIMARY_300';
        },
    },
    content: {
        padding: {
            none: '0',
            normal: '1.5rem',
        },
    },
};
export default tabs;
//# sourceMappingURL=tabs.js.map